<template>
  <v-scale-screen width="1920" height="1080" fullScreen>
    <div class="menu-board-container">
      <!-- 菜单主看板 -->
      <div class="menu-board">
        <!-- 1. 顶部 Header 区域 -->
        <header class="board-header">
          <!-- 左侧标题 -->
          <div class="title-area">
            <img
              class="title-image"
              src="https://shuwangysa.oss-cn-hangzhou.aliyuncs.com/uploads/20260821/ffe2b5049f4f80563d82133b378416c9.png"
              alt="今日菜单标题"
              title="点击全屏"
              @click="handleFullScreen"
            />
            <div class="date-tag">{{  currentDateStr}}</div>
          </div>

          <!-- 中间档口 / 餐次信息（上下结构，档口名可能较长） -->
          <div class="header-center">
            <div class="stall-name" :title="stallName">{{ stallName }}</div>
            <div class="meal-tag" v-if="mealName">
              <span class="meal-name">{{ mealName }}</span>
            </div>
          </div>

          <!-- 右侧今日推荐（轮播）：卡片常驻保持宽度，无推荐时隐藏角标/内容/边框 -->
          <div class="recommend-card" :class="{ 'recommend-empty': !currentRecommend }">
            <div class="recommend-badge" v-show="currentRecommend">今日推荐</div>
            <transition name="fade" mode="out-in">
              <div
                v-if="currentRecommend"
                class="recommend-content"
                :key="currentRecommend.id"
              >
                <div class="img-wrapper">
                  <img
                    :src="
                      currentRecommend.image ||
                      'https://shuwangysa.oss-cn-hangzhou.aliyuncs.com/uploads/20260819/ec502ef7265a0998b3672eab19618627.png'
                    "
                    :alt="currentRecommend.name"
                  />
                </div>
                <div class="recommend-info">
                  <div class="dish-name">{{ currentRecommend.name }}</div>
                  <div class="price-box">
                    <span class="symbol">¥</span>
                    <span class="amount">{{ currentRecommend.price.toFixed(1) }}</span>
                    <span class="unit">/{{ currentRecommend.unit }}</span>
                  </div>
                  <div class="reason" v-if="currentRecommend.reason">
                    <span class="label">推荐理由：</span>
                    <span>{{ currentRecommend.reason }}</span>
                  </div>
                </div>
                <!-- 图片提示：仅供参考（推荐卡片底部） -->
                <div class="img-tip">图片仅供参考，实际以出餐为主</div>
              </div>
            </transition>
          </div>
        </header>

        <!-- 2. 中间菜品列表区域（双列轮播） -->
        <main class="board-body">
          <!-- 左翻页按钮
          <button class="nav-btn prev-btn" @click="prevPage" :disabled="totalPages <= 1">
            ‹
          </button> -->

          <!-- 列表内容区域 -->
          <div class="menu-list-wrapper">
            <transition name="slide-fade" mode="out-in">
              <div
                class="columns-container"
                :class="{ 'single-column': columnsCount === 1 }"
                :key="currentPage"
              >
                <!-- 动态列：总数不超过单列行数时只渲染一列 -->
                <div
                  v-for="col in columnsCount"
                  :key="col"
                  class="menu-column"
                >
                  <div class="column-header">
                    <span class="col-title">菜品名称</span>
                    <span class="col-price">价格</span>
                  </div>
                  <ul class="dish-list">
                    <li
                      v-for="(item, index) in columnItems(col)"
                      :key="item.id"
                      class="dish-item"
                    >
                      <div class="dish-left">
                        <span class="dish-no">{{ formatNo(currentPage * pageSize + (col - 1) * rowsPerColumn + index + 1) }}</span>
                        <span class="dish-title">{{ item.name }}</span>
                      </div>
                      <div class="dish-price">
                        ¥{{ item.price.toFixed(1) }}<span class="unit">/{{ item.unit }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </transition>
          </div>

          <!-- 右翻页按钮 
          <button class="nav-btn next-btn" @click="nextPage" :disabled="totalPages <= 1">
            ›
          </button>-->
        </main>

        <!-- 3. 底部 Footer 提示栏 -->
        <footer class="board-footer">
          <div class="footer-notice">
            <img src="../assets/image/wenxin.png" style="width: 15px;margin-right: 10px;">
            <span>温馨提示：请按需取餐，珍惜粮食，杜绝浪费</span>
          </div>
          <div class="footer-time">
            <!-- <span class="icon">🕒</span> -->
            <!-- <span>{{ currentDateStr }}</span> -->
          </div>
        </footer>
      </div>
    </div>
  </v-scale-screen>
</template>

<script>
import { getTodayMenu } from "../api/api";
export default {
  name: "TodayMenu",
  data() {
    return {
      // 每一列显示的行数（写死为变量，如需调整直接修改此值即可）
      rowsPerColumn: 3,
      // 菜品列表当前页码（从 0 开始）
      currentPage: 0,
      // 今日推荐当前索引
      recommendIndex: 0,
      // 定时器句柄
      recommendTimer: null,
      menuTimer: null,

      // 当前日期字符串
      currentDateStr: "",

      // 档口名称（可能较长，展示在 header 中间区域）
      stallName: "",

      // 餐次名称
      mealName: "",

      // 营业时间（由后端 week_start / week_end 拼接，接口未返回时用默认值兜底）
      businessHours: "10:30 - 20:30",

      // 是否处于全屏状态（点击标题图片切换）
      fullscreen: false,

      // 今日推荐数据列表（由后端接口返回，用于自动图片/信息轮播）
      recommendList: [],

      // 全量菜品列表数据
      menuList: []
    };
  },
  computed: {
    // 列数：菜品总数不超过单列行数时只显示一列，否则显示两列
    columnsCount() {
      return this.menuList.length <= this.rowsPerColumn ? 1 : 2;
    },
    // 每页总显示条数 = 单列行数 * 列数
    pageSize() {
      return this.rowsPerColumn * this.columnsCount;
    },
    // 计算总页数
    totalPages() {
      return Math.ceil(this.menuList.length / this.pageSize) || 1;
    },
    // 当前推荐项（无数据时返回 null，配合 v-if 隐藏整个推荐区）
    currentRecommend() {
      return this.recommendList[this.recommendIndex] || null;
    },
    // 当前页显示的菜品片段
    currentPageItems() {
      const start = this.currentPage * this.pageSize;
      return this.menuList.slice(start, start + this.pageSize);
    },
  },
  mounted() {
    this.startTimers();
    this.getTodayMenuDate();
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    // 点击标题图片进入 / 退出全屏
    handleFullScreen() {
      const element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },

    // 根据列号（1 起）截取当前列应展示的菜品
    columnItems(col) {
      const start = (col - 1) * this.rowsPerColumn;
      return this.currentPageItems.slice(start, start + this.rowsPerColumn);
    },

    // 编号补零格式化 (如 1 -> "01")
    formatNo(num) {
      return String(num).padStart(2, "0");
    },

    // 上一页
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
      } else {
        this.currentPage = this.totalPages - 1; // 循环到最后一页
      }
    },

    // 下一页
    nextPage() {
      if (this.currentPage < this.totalPages - 1) {
        this.currentPage++;
      } else {
        this.currentPage = 0; // 循环回第一页
      }
    },

    // 开启定时自动轮播
    startTimers() {
      // 1. 今日推荐轮播（每 4 秒切换一次，仅当存在多条推荐时轮播）
      this.recommendTimer = setInterval(() => {
        if (this.recommendList.length > 1) {
          this.recommendIndex = (this.recommendIndex + 1) % this.recommendList.length;
        }
      }, 4000);

      // 2. 菜品列表翻页轮播（每 8 秒切换一次）
      this.menuTimer = setInterval(() => {
        if (this.totalPages > 1) {
          this.nextPage();
        }
      }, 8000);
    },

    // 清理定时器
    clearTimers() {
      if (this.recommendTimer) clearInterval(this.recommendTimer);
      if (this.menuTimer) clearInterval(this.menuTimer);
    },
    // 从当前页面 URL 解析 query 参数（不依赖 vue-router）
    parseUrlParams() {
      const params = {};
      const search = window.location.search;
      if (!search) return params;
      const pairs = search.substring(1).split('&');
      pairs.forEach((pair) => {
        if (!pair) return;
        const [key, value] = pair.split('=');
        if (key) {
          params[decodeURIComponent(key)] = value
            ? decodeURIComponent(value)
            : '';
        }
      });
      return params;
    },
    // 从 URL 获取参数并请求今日菜单
    async getTodayMenuDate() {
      const query = this.parseUrlParams();
      const params = {
        shop_id: query.shop_id,
        date: query.date || null,
        stall_name: query.stall_name,
        meal_name: query.meal_name
      };
      try {
        const res = await getTodayMenu(params);
        console.log(res, 'res');
        // 后端业务数据体（axios 的 res.data 为后端 JSON，业务字段在其 data 下）
        const biz = res && res.data && res.data.data;
        if (!biz) return;

        // 0. 当前日期字符串：由后端 today 与 week_day_text 拼接
        if (biz.today && biz.week_day_text) {
          this.currentDateStr = `${biz.today} ${biz.week_day_text}`;
        }

        // 0.1 营业时间：由后端 week_start 与 week_end 拼接
        if (biz.week_start && biz.week_end) {
          this.businessHours = `${biz.week_start} - ${biz.week_end}`;
        }

        // 0.2 档口名称与餐次：展示在 header 中间区域（档口名可能较长）
        if (biz.stall_name) {
          this.stallName = biz.stall_name;
        }
        if (biz.meal_name) {
          this.mealName = biz.meal_name;
        }

        // 0.3 每列行数：由后端 show_num 控制，非法值回退为默认 3
        if (biz.show_num && biz.show_num > 0) {
          this.rowsPerColumn = biz.show_num;
        }

        // 1. 今日推荐：后端为单个对象，转成展示用的数组结构
        const recommend = biz.recommend;
        if (recommend && recommend.name) {
          this.recommendList = [
            {
              id: recommend.id || `rec_${Date.now()}`,
              name: recommend.name,
              // 后端 price 为字符串，转成数字供 toFixed 使用
              price: Number(recommend.price) || 0,
              unit: recommend.unit || '份',
              reason: recommend.reason || '',
              image: recommend.image || ''
            }
          ];
          this.recommendIndex = 0;
        }

        // 2. 今日菜品列表：后端返回字段为 dishes（每项 { name, price }）
        //    映射为页面使用的 menuList 结构 { id, name, price, unit }
        const dishes =
          biz.dishes ||
          biz.menuList ||
          biz.menu ||
          biz.dishList ||
          biz.list ||
          biz.items ||
          biz.menus ||
          biz.todayMenu;
        if (Array.isArray(dishes) && dishes.length) {
          this.menuList = dishes.map((d, index) => ({
            // 后端无 id 时按下标生成，保证 :key 可用
            id: d.id != null ? d.id : index + 1,
            // 后端 name 字段名与 mock 一致
            name: d.name || d.dish_name || d.food_name || '未知菜品',
            // 后端 price 为字符串，转成数字供模板 toFixed 使用
            price: Number(d.price) || 0,
            // 后端无 unit 时默认"份"
            unit: d.unit || '份'
          }));
          this.currentPage = 0;
        }
      } catch (e) {
        // 请求失败时保留页面内置的 mock 数据兜底
        console.error('获取今日菜单失败：', e);
      }
    },
  }
};
</script>

<style scoped>
/* 全局变量与容器设置 */
.menu-board-container {
  width: 1920px;
  height: 1080px;
  display: flex;
  flex-direction: column;
  background-color: #f0f2f5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  box-sizing: border-box;
}

/* 电子菜单主板外观：铺满整个画布 */
.menu-board {
  width: 100%;
  height: 100%;
  background: #f7f9f6;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  border: 1px solid #e1e8e3;
  display: flex;
  flex-direction: column;
}

/* 1. Header 样式 */
.board-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 64px 24px 64px;
  background: #ffffff;
  flex-shrink: 0;
}

.title-area {
  display: flex;
  flex-direction: column;
}

.title-image {
  width: 380px;
  height: 200px;
  display: block;
}

.date-tag {
  margin-top: 20px;
  margin-left: 20px;
  font-size: 45px;
  font-weight: bold;
  color: #1a4d2e;
  /* text-decoration: underline; */
  /* text-underline-offset: 6px; */
}

/* 中间档口 / 餐次信息 */
.header-center {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 0 40px;
}

.stall-name {
  font-size: 114px;
  font-weight: 900;
  color: #1a4d2e;
  letter-spacing: 3px;
  text-align: center;
  line-height: 1.35;
  max-width: 100%;
  word-break: break-all;
}

.meal-tag {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #2e8b57, #1a4d2e);
  color: #ffffff;
  font-size: 56px;
  font-weight: 600;
  padding: 5px 26px;
  border-radius: 19px;
  box-shadow: 0 6px 16px rgba(26, 77, 46, 0.3);
  white-space: nowrap;
}

.meal-icon {
  font-size: 24px;
}

/* 今日推荐卡片 */
.recommend-card {
  position: relative;
  display: flex;
  align-items: center;
  width: 30%;
  height: 250px;
  background: #ffffff;
  border: 2px solid #f97316;
  border-radius: 16px;
  /* 底部预留提示条空间 */
  padding: 18px 18px 62px;
  box-sizing: border-box;
}

/* 无推荐时：保留宽度占位，去掉边框 */
.recommend-card.recommend-empty {
  border: none;
}

.recommend-badge {
  /* 绝对定位贴住卡片右上角，仅改位置，样式不变 */
  position: absolute;
  top: -1px;
  right: -1px;
  background: linear-gradient(135deg, #ff7e1d, #f97316);
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
  padding: 6px 24px;
  border-top-left-radius: 14px;
  border-bottom-right-radius: 16px;
  box-shadow: 2px 2px 5px rgba(249, 115, 22, 0.2);
  white-space: nowrap;
}

.recommend-content {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  height: 100%;
  /* margin-left: 16px; */
  /* margin-top: 15px; */
}

.img-wrapper {
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
}

.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 推荐卡片底部提示条 */
.img-tip {
  position: absolute;
  left: 20px;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  color: #FE7C1C;
  font-size: 18px;
  line-height: 1.4;
  text-align: center;
  padding: 8px 4px;
}

.recommend-info {
  flex: 1;
  min-width: 0;
  margin-left: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  /* height: 130px; */
}

.recommend-info .dish-name {
  font-size: 46px;
  font-weight: bold;
  color: #1a1a1a;
  /* 只显示一行，超出省略 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recommend-info .price-box {
  color: #f97316;
  font-weight: bold;
}

.recommend-info .price-box .symbol {
  font-size: 18px;
}

.recommend-info .price-box .amount {
  font-size: 46px;
}

.recommend-info .price-box .unit {
  font-size: 16px;
  color: #666;
}

.recommend-info .reason {
  font-size: 20px;
  color: #4b5563;
  line-height: 1.4;
  /* 最多显示两行，超出省略 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  word-break: break-all;
}

.recommend-info .reason .label {
  color: #16a34a;
  /* font-weight: bold; */
}

/* 2. 主体列表区域样式 */
.board-body {
  position: relative;
  flex: 1 1 0%;
  min-height: 0;
  padding: 16px 28px;
  display: flex;
  align-items: stretch;
}

.nav-btn {
  background: #ffffff;
  border: 1px solid #d1d5db;
  color: #4b5563;
  width: 56px;
  height: 96px;
  border-radius: 28px;
  font-size: 36px;
  cursor: pointer;
  outline: none;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  align-self: center;
}

.nav-btn:hover:not(:disabled) {
  background: #105432;
  color: #ffffff;
  border-color: #105432;
}

.nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.menu-list-wrapper {
  flex: 1;
  margin: 0 12px;
  overflow: hidden;
  min-width: 0;
}

.columns-container {
  display: flex;
  gap: 36px;
  height: 100%;
}

/* 单列模式：列宽为两列合并的宽度，撑满整个容器 */
.columns-container.single-column {
  gap: 0;
}

.menu-column {
  flex: 1;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
}

.column-header {
  background-color: #105432;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  padding: 18px 40px;
  font-weight: bold;
  font-size: 28px;
  flex-shrink: 0;
}

.dish-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.dish-item {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid #f0f0f0;
}

/* 当列中只有一个菜品时，不拉伸填满列表，从顶部按顺序排列 */
.dish-item:only-child {
  flex: 0 0 auto;
  min-height: 110px;
}

.dish-item:last-child {
  border-bottom: none;
}

.dish-left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.dish-no {
  background-color: #105432;
  color: #ffffff;
  font-size: 34px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 16px;
  margin-right: 18px;
}

.dish-title {
  font-size: 40px;
  font-weight: bold;
  color: #222222;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dish-price {
  font-size: 42px;
  font-weight: bold;
  color: #f97316;
  flex-shrink: 0;
}

.dish-price .unit {
  font-size: 18px;
  color: #666;
  font-weight: normal;
}

/* 3. 底部 Footer 样式 */
.board-footer {
  background-color: #105432;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 48px;
  font-size: 20px;
  font-weight: 500;
  flex-shrink: 0;
}

.footer-notice, .footer-time {
  display: flex;
  align-items: center;
}

.footer-notice .icon, .footer-time .icon {
  margin-right: 10px;
  font-size: 22px;
}

/* 过渡动画 */
/* 淡入淡出 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 列表切页动画 */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter {
  opacity: 0;
  transform: translateX(10px);
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}
</style>
